






































import { editName } from '@/main/store/listEditTypes';
import { editFactory } from '@/main/pages/editFactory';
import { showAlert } from '@/main/utils/notifications';

import { apiProvider } from './api';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	methods: {
		isvalueChange() {
			const result = {} as any;
			this.dropdownList.OrganizationId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
			this.LocationCode = this.LocationId === null ? 1 : this.LocationId + 1;
			this.Code = result[this.OrganizationId === null ? 0 : this.OrganizationId].slice(0, 2) + this.LocationCode;
		},
		async saveClick() {
			if (this.Code !== null && this.OrganizationId !== null && this.LocationId !== null) {
				this.startLoading();
				const { data: locationCode } = await apiProvider.validateLocationCode(this.Code, this.OrganizationId, this.LocationId);
				this.endLoading();
				if (locationCode) {
					showAlert({
						message: this.LocalizeChyboveHlasky('LocationCodeAlert'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}
			}
			await this.save();
		},
	},

});
